var map = {
	"./Tailing.svg": "UMQA",
	"./Telegram.svg": "ISK4",
	"./TinkLogo.svg": "LKUT",
	"./WalletCoins.svg": "17S6",
	"./arrow-hover.svg": "ifth",
	"./arrow.svg": "7Hhe",
	"./at-sign.svg": "5bdt",
	"./bank.svg": "hkzh",
	"./blue-ticketn.svg": "Succ",
	"./calendar.svg": "ky10",
	"./card-icon-active.svg": "zCFC",
	"./card-icon.svg": "jAFc",
	"./check.svg": "LI6s",
	"./copy-white.svg": "AlpV",
	"./copy.svg": "zsfP",
	"./crown-black.svg": "poQg",
	"./crown-grey.svg": "oc8n",
	"./crown-hover.svg": "UhBp",
	"./crown-new.svg": "40jd",
	"./crown.svg": "afP4",
	"./derivation-arrow.svg": "DZGq",
	"./derivation-money.svg": "G45s",
	"./derivation-ticket.svg": "oxUr",
	"./divider.svg": "dTSR",
	"./edit-icon.svg": "sh4P",
	"./error.svg": "4lnY",
	"./erroricon.svg": "hadQ",
	"./exchange.svg": "MmyJ",
	"./eye-off.svg": "kB6H",
	"./eye.svg": "YFNw",
	"./file-shield-02.svg": "OxX6",
	"./first.svg": "LWTa",
	"./gold-arrow.svg": "1D1j",
	"./green-blue-ticket.svg": "Bgpl",
	"./green-ticket.svg": "jBBA",
	"./green-ticketn.svg": "B0kY",
	"./left-swipe.svg": "lEwS",
	"./point-disabled.svg": "kRNq",
	"./point.svg": "32Qn",
	"./profile-tab-1-dark.svg": "KQwF",
	"./profile-tab-1.svg": "gEVT",
	"./profile-tab-2-dark.svg": "Kbrp",
	"./profile-tab-2.svg": "ku4g",
	"./profile-tab-3-dark.svg": "2Z9C",
	"./profile-tab-3.svg": "7kYJ",
	"./profile-tab-4-dark.svg": "HWTw",
	"./profile-tab-4.svg": "pAS8",
	"./profile-tab-5-dark.svg": "ULDN",
	"./profile-tab-5.svg": "rHgF",
	"./profile-tab-6-dark.svg": "F1Ct",
	"./profile-tab-6.svg": "q+YO",
	"./profile-tab-7-dark.svg": "kW89",
	"./profile-tab-7.svg": "YTx/",
	"./profile-tab-8-dark.svg": "IFoM",
	"./profile-tab-8.svg": "U7O8",
	"./randomAvatar.svg": "5dLQ",
	"./referrals.svg": "ZTIu",
	"./restTrophy.svg": "mZ6F",
	"./right-swipe.svg": "h8+7",
	"./sbp-icon-active.svg": "8gjB",
	"./sbp-icon.svg": "+s58",
	"./second.svg": "0vCy",
	"./shield.svg": "9v9c",
	"./social-copy.svg": "HlmL",
	"./social-facebook.svg": "xBIY",
	"./social-insta.svg": "KEKZ",
	"./social-telegram.svg": "IuzO",
	"./social-twitter.svg": "Rr/U",
	"./social-viber.svg": "SpIq",
	"./social-vk.svg": "RJsN",
	"./social-whatsapp.svg": "AEbl",
	"./star.svg": "2X4u",
	"./success.svg": "nHd0",
	"./third.svg": "LL9/",
	"./transactions-icon.svg": "fl7l",
	"./uploadIncon.svg": "p1j+",
	"./user.svg": "Km1V",
	"./wallet.svg": "6xR6",
	"./warning.svg": "ET3/",
	"./white-crown.svg": "afQR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 31